module.exports = __webpack_public_path__ + "static/media/01-galeria-02-bottega-venetta@2x.2e273010.jpg";